<div class="drug-count">
  {{
    (totalRows !== undefined && totalRows !== null ? totalRows : "-") +
      " Rows Listed"
  }}
  <span
    class="info-class"
    *ngIf="gridSettings.options.filter.indication.length > 0"
  >
    <i
      nz-popover
      nzPopoverPlacement="right"
      [nzPopoverContent]="countPopoverTemplate"
      nzPopoverTrigger="hover"
      class="info-icon"
    >
      <va-icon size="small" name="info-circle"></va-icon>
    </i>
  </span>
</div>

<ng-template #countPopoverTemplate>
  <div>
    <span> Listed rows where: </span>
  </div>
  <div>
    <span>
      Indication-Specific Revenue is Available:
      {{ totalRows - consolidatedTotal }}
    </span>
  </div>
  <div>
    <span>
      Indication-Specific Revenue is Not Available: {{ consolidatedTotal }}
    </span>
  </div>
</ng-template>

<div class="grid-container">
  <div
    class="grid-container-scroll"
    #divScroll
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="20"
    [infiniteScrollDisabled]="scrollDisabled"
    [scrollWindow]="false"
    (scrolled)="loadMoreItems()"
    [ngClass]="{
      'fixed-scroll': totalRows >= 20
    }"
  >
    <div class="error-container" *ngIf="showError && isGridReady">
      <div class="error-msg">
        <va-icon name="info-circle" class="info-icon"></va-icon>
        <span class="error-text">{{
          errorMsg ? errorMsg : "Something went wrong"
        }}</span>
      </div>
    </div>
    <table
      mat-table
      matSort
      matSortActive="{{ sortKey }}"
      matSortDirection="desc"
      #sortObj="matSort"
      (matSortChange)="sortData($event)"
      [dataSource]="dataSource"
      class="drug-table"
      *ngIf="!showError && !forceRerender"
      cellpadding="0"
      cellspacing="0"
    >
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <!-- Drug name column def  -->
      <ng-container matColumnDef="drug_name" sticky class="table-header">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="drug_name">
          <span class="header-text">{{ gridColNames.drug_name }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="drug-name-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span
              class="cell-value"
              *ngIf="elem.dataObj.breakout_list.length > 0"
              (click)="openDrug(elem)"
            >
              <!-- check for expansion and add -->
              <span class="icon-box">
                <va-icon
                  size="small"
                  name="caret-right"
                  class="row-expand-icon"
                  *ngIf="
                    !elem.dataObj.rowExpandedLoading &&
                    !elem.dataObj.rowExpanded
                  "
                  (dblclick)="handleDoubleClick(elem, undefined, $event)"
                  (click)="handleSingleClick(elem, undefined, $event)"
                ></va-icon>
                <va-icon
                  size="small"
                  name="caret-down"
                  class="row-expand-icon"
                  *ngIf="
                    !elem.dataObj.rowExpandedLoading && elem.dataObj.rowExpanded
                  "
                  (dblclick)="handleDoubleClick(elem, undefined, $event)"
                  (click)="handleSingleClick(elem, undefined, $event)"
                ></va-icon>
                <nz-spin
                  *ngIf="elem.dataObj.rowExpandedLoading"
                  nzSimple
                  [nzIndicator]="indicatorTemplate"
                >
                </nz-spin>
                <ng-template #indicatorTemplate>
                  <va-icon
                    [isFontAwesome]="true"
                    [name]="faSpinner"
                    [spin]="true"
                    class="va-button-icon"
                  ></va-icon>
                </ng-template>
              </span>
              <span class="drug-name" [title]="elem.dataObj.drug_name">{{
                elem.dataObj.drug_name
              }}</span>
            </span>
            <span
              class="cell-value"
              *ngIf="elem.dataObj.breakout_list.length === 0"
              (click)="openDrug(elem)"
            >
              <span class="icon-box"></span>
              <span
                class="drug-name single-name"
                [title]="elem.dataObj.drug_name"
                [ngClass]="{
                  'is-child': elem.parentCtag && elem.parentCtag !== ''
                }"
                >{{ elem.dataObj.drug_name }}</span
              >
            </span>
          </ng-container>
          <!-- remove modal once drug page release is confirmed -->
          <nz-modal
            nzWrapClassName="vertical-center-modal"
            nzClassName="coming-soon-modal-container"
            [(nzVisible)]="showDrugModal"
            nzTitle="Drug Pages"
            [nzFooter]="null"
            nzWidth="950px"
            (nzOnCancel)="closeModal()"
            class="modal"
          >
            <div nz-row [nzGutter]="48">
              <div nz-col nzSpan="14" class="modal-image">
                <!-- Image section -->
                <img
                  class="moadal-image"
                  [src]="assets + '/coming-soon-modal.png'"
                />
              </div>
              <div nz-col nzSpan="8" class="centered">
                <!-- Text section -->
                <!-- <div class="spacing"> -->
                <p class="modal-content-heading">
                  Granular consensus data for 6,500+ drugs
                </p>
                <p class="modal-content-date">Coming soon</p>
                <h5 class="modal-content-paragarph">
                  Drug pages will consolidate all available consensus drug data,
                  enabling you to understand market expectations and the
                  assumptions behind those estimates.
                </h5>
                <!-- </div> -->
              </div>
            </div>
          </nz-modal>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          {{ "Total" }}
        </td>
      </ng-container>

      <!-- Ticker column def  -->
      <ng-container matColumnDef="ticker" sticky class="table-header">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="ticker">
          <span class="header-text">{{ gridColNames.ticker }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="ticker-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <a
              routerLink="{{ '/company/' + elem.dataObj.ticker }}"
              routerLinkActive
              target="_blank"
              [title]="elem.dataObj.companyname"
            >
              {{ elem.dataObj.ticker }}
            </a>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Indications by Phase column def  -->
      <ng-container matColumnDef="indications">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.indications }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="indication-cell"
          (contextmenu)="cellContextMenu($event, elem, 'indications')"
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name +
                '_' +
                elem.dataObj.ticker +
                '|' +
                'indications'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <div class="cell-value">
              <!-- multiple values -->
              <ng-container
                *ngFor="let val of elem.dataObj.indications; let i = index"
              >
                <div class="first-row row" *ngIf="i === 0">
                  <span class="indications-phase" [title]="val.phase">{{
                    phaseAbbr[val.phase]
                  }}</span>
                  <span
                    class="indications-name val"
                    [ngClass]="{
                      'single-val': elem.dataObj.indications.length === 1
                    }"
                    [title]="val.name"
                    >{{ val.name }}</span
                  >
                  <span
                    *ngIf="elem.dataObj.indications.length > 1"
                    class="count-span"
                  >
                    <span
                      class="icon-box"
                      (click)="
                        expandCell(elem.dataObj.indications, 'indications')
                      "
                    >
                      <ng-container *ngIf="!elem.dataObj.indications.expanded">
                        (+ {{ elem.dataObj.indications.length - 1 }})

                        <va-icon
                          size="small"
                          name="expand-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                      <ng-container *ngIf="elem.dataObj.indications.expanded">
                        <va-icon
                          size="small"
                          name="collapse-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                    </span>
                  </span>
                </div>
                <div
                  class="other-row row"
                  *ngIf="i !== 0 && elem.dataObj.indications.expanded"
                >
                  <span
                    class="indications-phase"
                    *ngIf="val.phase"
                    [title]="val.phase"
                    >{{ phaseAbbr[val.phase] }}</span
                  >
                  <span
                    class="indications-name val single-val"
                    [title]="val.name"
                    >{{ val.name }}</span
                  >
                </div>
              </ng-container>
            </div>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- MOA column def  -->
      <ng-container matColumnDef="moa">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.moa }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="moa-cell"
          (contextmenu)="cellContextMenu($event, elem, 'moa')"
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name + '_' + elem.dataObj.ticker + '|' + 'moa'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <div class="cell-value">
              <!-- multiple values -->
              <div *ngFor="let val of elem.dataObj.moa; let i = index">
                <div class="first-row row" *ngIf="i === 0">
                  <span
                    class="val"
                    [ngClass]="{
                      'single-val': elem.dataObj.moa.length === 1
                    }"
                    [title]="val.name"
                  >
                    {{ val.name }}
                  </span>
                  <span *ngIf="elem.dataObj.moa.length > 1">
                    <span
                      class="icon-box"
                      (click)="expandCell(elem.dataObj.moa, 'moa')"
                    >
                      <ng-container *ngIf="!elem.dataObj.moa.expanded">
                        (+ {{ elem.dataObj.moa.length - 1 }})
                        <va-icon
                          size="small"
                          name="expand-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                      <ng-container *ngIf="elem.dataObj.moa.expanded">
                        <va-icon
                          size="small"
                          name="collapse-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                    </span>
                  </span>
                </div>
                <div
                  class="other-row row"
                  *ngIf="i !== 0 && elem.dataObj.moa.expanded"
                >
                  <span class="val single-val" [title]="val.name">{{
                    val.name
                  }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Target column def  -->
      <ng-container matColumnDef="target">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.target }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="target-cell"
          (contextmenu)="cellContextMenu($event, elem, 'target')"
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name +
                '_' +
                elem.dataObj.ticker +
                '|' +
                'target'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <div class="cell-value">
              <!-- multiple values -->
              <div *ngFor="let val of elem.dataObj.target; let i = index">
                <div class="first-row row" *ngIf="i === 0">
                  <span
                    class="val"
                    [ngClass]="{
                      'single-val': elem.dataObj.target.length === 1
                    }"
                    [title]="val.name"
                  >
                    {{ val.name }}
                  </span>
                  <span *ngIf="elem.dataObj.target.length > 1">
                    <span
                      class="icon-box"
                      (click)="expandCell(elem.dataObj.target, 'target')"
                    >
                      <ng-container *ngIf="!elem.dataObj.target.expanded">
                        (+ {{ elem.dataObj.target.length - 1 }})
                        <va-icon
                          size="small"
                          name="expand-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                      <ng-container *ngIf="elem.dataObj.target.expanded">
                        <va-icon
                          size="small"
                          name="collapse-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                    </span>
                  </span>
                </div>
                <div
                  class="other-row row"
                  *ngIf="i !== 0 && elem.dataObj.target.expanded"
                >
                  <span class="val single-val" [title]="val.name">{{
                    val.name
                  }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- lines column def  -->
      <ng-container matColumnDef="lines">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="lines">
          <span class="header-text">{{ gridColNames.lines }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="lines-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <div class="cell-value">
              {{ !elem.dataObj.isBreakout ? elem.dataObj.lines : "" }}
            </div>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Commercial status def -->
      <ng-container matColumnDef="commercial_status">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.commercial_status }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="lines-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              {{ elem.dataObj.commercial_status }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Company name column def  -->
      <ng-container matColumnDef="companyname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="companyname">
          <span class="header-text">{{ gridColNames.companyname }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="company-name-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <div class="row">
              <span
                class="cell-value val single-val"
                [title]="elem.dataObj.companyname"
              >
                {{ elem.dataObj.companyname }}
              </span>
            </div>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Therapeutic Area column def  -->
      <ng-container matColumnDef="therapeutic_area">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="therapeutic_area"
        >
          <span class="header-text">{{ gridColNames.therapeutic_area }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="therapeutic-area-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              {{ elem.dataObj.therapeutic_area }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- POS point of sale column def  -->
      <ng-container matColumnDef="probability_of_success">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="probability_of_success"
        >
          <span class="header-text">{{
            gridColNames.probability_of_success
          }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="pos-cell"
          (click)="
            loadFormulaBarNonPeriod(
              elem.dataObj,
              'pos',
              elem.ctag,
              elem.parentCtag
            )
          "
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name + '_' + elem.dataObj.ticker + '|' + 'pos'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span
              class="cell-value"
              *ngIf="elem.dataObj.probability_of_success !== null"
            >
              {{ elem.dataObj.probability_of_success | number: "1.2-2"
              }}<ng-container
                *ngIf="
                  elem.dataObj.probability_of_success !== null &&
                  elem.dataObj.probability_of_success !== undefined
                "
                >%</ng-container
              >
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- launch year column def  -->
      <ng-container matColumnDef="launch_year">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="launch_year">
          <span class="header-text">{{ gridColNames.launch_year }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="launch-yr-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <div class="cell-value">
              {{ elem.dataObj.launch_year }}
            </div>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Approval Date column def  -->
      <ng-container matColumnDef="approval_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="approval_date">
          <span class="header-text">{{ gridColNames.approval_date }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="approval-date-cell"
          (contextmenu)="cellContextMenu($event, elem, 'approval_date')"
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name +
                '_' +
                elem.dataObj.ticker +
                '|' +
                'approval_date'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <div
              class="cell-value"
              *ngIf="isDate(elem.dataObj.approval_date); else elseBlock"
            >
              {{ elem.dataObj.approval_date | date: "dd-MMM-yyyy" }}
            </div>
            <ng-template #elseBlock>{{
              elem.dataObj.approval_date
            }}</ng-template>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Peak sales column def  -->
      <ng-container matColumnDef="peak_value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="peak_value">
          <span class="header-text">{{ gridColNames.peak_value }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="peak-sales-cell"
          (click)="
            loadFormulaBarNonPeriod(
              elem.dataObj,
              'peak_sales',
              elem.ctag,
              elem.parentCtag
            )
          "
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name +
                '_' +
                elem.dataObj.ticker +
                '|' +
                'peak_sales'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container
            *ngIf="!elem.dataObj.isLoading && elem.dataObj.peak_value"
          >
            <span class="cell-value">
              {{ elem.dataObj.peak_value.value }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Peak sales year column def  -->
      <ng-container matColumnDef="peak_year">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="peak_year">
          <span class="header-text">{{ gridColNames.peak_year }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="peak-year-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              {{ elem.dataObj.peak_year }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Drug type column def  -->
      <ng-container matColumnDef="drug_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="drug_type">
          <span class="header-text">{{ gridColNames.drug_type }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="drug-type-cell"
          (contextmenu)="cellContextMenu($event, elem, 'drug_type')"
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name +
                '_' +
                elem.dataObj.ticker +
                '|' +
                'drug_type'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              {{ elem.dataObj.drug_type }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Drug class column def  -->
      <ng-container matColumnDef="drug_class">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.drug_class }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="drug-class-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              <!-- multiple values -->

              <div *ngFor="let val of elem.dataObj.drug_class; let i = index">
                <div class="first-row row" *ngIf="i === 0">
                  <span
                    class="val"
                    [ngClass]="{
                      'single-val': elem.dataObj.drug_class.length === 1
                    }"
                    [title]="val.name"
                    >{{ val.name }}</span
                  >
                  <span *ngIf="elem.dataObj.drug_class.length > 1">
                    <span
                      class="icon-box"
                      (click)="
                        expandCell(elem.dataObj.drug_class, 'drug_class')
                      "
                    >
                      <ng-container *ngIf="!elem.dataObj.drug_class.expanded">
                        (+ {{ elem.dataObj.drug_class.length - 1 }})
                        <va-icon
                          size="small"
                          name="expand-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>

                      <ng-container *ngIf="elem.dataObj.drug_class.expanded">
                        <va-icon
                          size="small"
                          name="collapse-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                    </span>
                  </span>
                </div>
                <div
                  class="other-row row"
                  *ngIf="i !== 0 && elem.dataObj.drug_class.expanded"
                >
                  <span class="val single-val" [title]="val.name">{{
                    val.name
                  }}</span>
                </div>
              </div>
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- API column def  -->
      <ng-container matColumnDef="api">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.api }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="api-cell"
          (contextmenu)="cellContextMenu($event, elem, 'api')"
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name + '_' + elem.dataObj.ticker + '|' + 'api'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              <!-- multiple values -->
              <div *ngFor="let val of elem.dataObj.api; let i = index">
                <div class="first-row row" *ngIf="i === 0">
                  <span
                    class="val"
                    [ngClass]="{
                      'single-val': elem.dataObj.api.length === 1
                    }"
                    [title]="val.name"
                    >{{ val.name }}</span
                  >
                  <span *ngIf="elem.dataObj.api.length > 1">
                    <span
                      class="icon-box"
                      (click)="expandCell(elem.dataObj.api, 'api')"
                    >
                      <ng-container *ngIf="!elem.dataObj.api.expanded">
                        (+ {{ elem.dataObj.api.length - 1 }})
                        <va-icon
                          size="small"
                          name="expand-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                      <ng-container *ngIf="elem.dataObj.api.expanded">
                        <va-icon
                          size="small"
                          name="collapse-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                    </span>
                  </span>
                </div>
                <div
                  class="other-row row"
                  *ngIf="i !== 0 && elem.dataObj.api.expanded"
                >
                  <span class="val single-val" [title]="val.name">{{
                    val.name
                  }}</span>
                </div>
              </div>
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- delivery mechanism column def  -->
      <ng-container matColumnDef="delivery_mechanism">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.delivery_mechanism }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="delivery-mechanism-cell"
          (contextmenu)="cellContextMenu($event, elem, 'delivery_mechanism')"
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name +
                '_' +
                elem.dataObj.ticker +
                '|' +
                'delivery_mechanism'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              <!-- multiple values -->
              <div
                *ngFor="
                  let val of elem.dataObj.delivery_mechanism;
                  let i = index
                "
              >
                <div class="first-row row" *ngIf="i === 0">
                  <span
                    class="val"
                    [ngClass]="{
                      'single-val': elem.dataObj.delivery_mechanism.length === 1
                    }"
                    [title]="val.name"
                    >{{ val.name }}</span
                  >
                  <span *ngIf="elem.dataObj.delivery_mechanism.length > 1">
                    <span
                      class="icon-box"
                      (click)="
                        expandCell(
                          elem.dataObj.delivery_mechanism,
                          'delivery_mechanism'
                        )
                      "
                    >
                      <ng-container
                        *ngIf="!elem.dataObj.delivery_mechanism.expanded"
                      >
                        (+ {{ elem.dataObj.delivery_mechanism.length - 1 }})
                        <va-icon
                          size="small"
                          name="expand-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                      <ng-container
                        *ngIf="elem.dataObj.delivery_mechanism.expanded"
                      >
                        <va-icon
                          size="small"
                          name="collapse-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                    </span>
                  </span>
                </div>
                <div
                  class="other-row row"
                  *ngIf="i !== 0 && elem.dataObj.delivery_mechanism.expanded"
                >
                  <span class="val single-val" [title]="val.name">{{
                    val.name
                  }}</span>
                </div>
              </div>
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- revenue type column def  -->
      <ng-container matColumnDef="revenue_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="revenue_type">
          <span class="header-text">{{ gridColNames.revenue_type }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="revenue-type-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              {{ elem.dataObj.revenue_type }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- generic_biosimilar column def  -->
      <ng-container matColumnDef="generic_biosimilar">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.generic_biosimilar }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="generic-biosimilar-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              <!-- multiple values -->
              <div
                *ngFor="
                  let val of elem.dataObj.generic_biosimilar;
                  let i = index
                "
              >
                <div class="first-row row" *ngIf="i === 0">
                  <span
                    class="val"
                    [ngClass]="{
                      'single-val': elem.dataObj.generic_biosimilar.length === 1
                    }"
                    [title]="val.name"
                    >{{ val.name }}</span
                  >
                  <span *ngIf="elem.dataObj.generic_biosimilar.length > 1">
                    <span
                      class="icon-box"
                      (click)="
                        expandCell(
                          elem.dataObj.generic_biosimilar,
                          'generic_biosimilar'
                        )
                      "
                    >
                      <ng-container
                        *ngIf="!elem.dataObj.generic_biosimilar.expanded"
                      >
                        (+ {{ elem.dataObj.generic_biosimilar.length - 1 }})
                        <va-icon
                          size="small"
                          name="expand-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                      <ng-container
                        *ngIf="elem.dataObj.generic_biosimilar.expanded"
                      >
                        <va-icon
                          size="small"
                          name="collapse-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                    </span>
                  </span>
                </div>
                <div
                  class="other-row row"
                  *ngIf="i !== 0 && elem.dataObj.generic_biosimilar.expanded"
                >
                  <span class="val single-val" [title]="val.name">{{
                    val.name
                  }}</span>
                </div>
              </div>
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- alias name column def  -->
      <ng-container matColumnDef="alias_name">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.alias_name }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="alias-name-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              <!-- multiple values -->
              <div *ngFor="let val of elem.dataObj.alias_name; let i = index">
                <div class="first-row row" *ngIf="i === 0">
                  <span
                    class="val"
                    [ngClass]="{
                      'single-val': elem.dataObj.alias_name.length === 1
                    }"
                    [title]="val.name"
                    >{{ val.name }}</span
                  >
                  <span *ngIf="elem.dataObj.alias_name.length > 1">
                    <span
                      class="icon-box"
                      (click)="
                        expandCell(elem.dataObj.alias_name, 'alias_name')
                      "
                    >
                      <ng-container *ngIf="!elem.dataObj.alias_name.expanded">
                        (+ {{ elem.dataObj.alias_name.length - 1 }})
                        <va-icon
                          size="small"
                          name="expand-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                      <ng-container *ngIf="elem.dataObj.alias_name.expanded">
                        <va-icon
                          size="small"
                          name="collapse-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                    </span>
                  </span>
                </div>
                <div
                  class="other-row row"
                  *ngIf="i !== 0 && elem.dataObj.alias_name.expanded"
                >
                  <span class="val single-val" [title]="val.name">{{
                    val.name
                  }}</span>
                </div>
              </div>
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- originator_licensee column def  -->
      <ng-container matColumnDef="originator_licensee">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text" [title]="">
            {{ gridColNames.originator_licensee }}
          </span>
        </th>
        <td mat-cell *matCellDef="let elem" class="originator-licensee-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              <!-- multiple values -->
              <div
                *ngFor="
                  let val of elem.dataObj.originator_licensee;
                  let i = index
                "
              >
                <div class="first-row row" *ngIf="i === 0">
                  <span
                    class="val"
                    [ngClass]="{
                      'single-val':
                        elem.dataObj.originator_licensee.length === 1
                    }"
                    [title]="val.name"
                    >{{ val.name }}</span
                  >
                  <span *ngIf="elem.dataObj.originator_licensee.length > 1">
                    <span
                      class="icon-box"
                      (click)="
                        expandCell(
                          elem.dataObj.originator_licensee,
                          'originator_licensee'
                        )
                      "
                    >
                      <ng-container
                        *ngIf="!elem.dataObj.originator_licensee.expanded"
                      >
                        (+ {{ elem.dataObj.originator_licensee.length - 1 }})
                        <va-icon
                          size="small"
                          name="expand-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                      <ng-container
                        *ngIf="elem.dataObj.originator_licensee.expanded"
                      >
                        <va-icon
                          size="small"
                          name="collapse-arrows"
                          class="expand-icon"
                        ></va-icon>
                      </ng-container>
                    </span>
                  </span>
                </div>
                <div
                  class="other-row row"
                  *ngIf="i !== 0 && elem.dataObj.originator_licensee.expanded"
                >
                  <span class="val single-val" [title]="val.name">{{
                    val.name
                  }}</span>
                </div>
              </div>
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Expiry date column def  -->
      <ng-container matColumnDef="expiry_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="expiry_date">
          <span class="header-text">{{ gridColNames.expiry_date }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="expiry-date-cell"
          (contextmenu)="cellContextMenu($event, elem, 'expiry_date')"
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name +
                '_' +
                elem.dataObj.ticker +
                '|' +
                'expiry_date'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <div
              class="cell-value"
              *ngIf="isDate(elem.dataObj.expiry_date); else elseBlock"
            >
              {{ elem.dataObj.expiry_date | date: "dd-MMM-yyyy" }}
            </div>
            <ng-template #elseBlock>{{ elem.dataObj.expiry_date }}</ng-template>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- excel code column def  -->
      <ng-container matColumnDef="dapparameter">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.dapparameter }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="excel-code-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              {{ elem.dataObj.dapparameter }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- drug id code column def  -->
      <ng-container matColumnDef="ctagid">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.ctagid }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="drug-id-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container
            *ngIf="
              !elem.dataObj.isLoading &&
              elem.dataObj.consolidated &&
              !gridSettings.options.filter.geo.length &&
              (gridSettings.options.filter.indication.length === 0 ||
                (gridSettings.options.filter.indication.length > 0 && showNIB))
            "
          >
            <span class="cell-value">
              {{ elem.dataObj.ctagid }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- aggregate_year_5 column def  -->
      <ng-container matColumnDef="aggregate_year_5">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="aggregate_year_5"
        >
          <span class="header-text">{{ gridColNames.aggregate_year_5 }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="aggr-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container
            *ngIf="!elem.dataObj.isLoading && elem.dataObj.aggregate_year_5"
          >
            <span class="cell-value">
              {{ elem.dataObj.aggregate_year_5.value }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- geography column def  -->
      <ng-container matColumnDef="geography">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.geography }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="geo-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container
            *ngIf="!elem.dataObj.isLoading && elem.dataObj.geography"
          >
            <span class="cell-value">
              {{ elem.dataObj.geography }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Available geography column def -->
      <ng-container matColumnDef="available_geography">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{
            gridColNames.available_geography
          }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="geo-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container
            *ngIf="!elem.dataObj.isLoading && elem.dataObj.available_geography"
          >
            <span class="cell-value">
              <span
                *ngFor="
                  let val of elem.dataObj.available_geography;
                  let last = last
                "
                [title]="val.name"
              >
                {{ val.name }}<span *ngIf="!last">, </span>
              </span>
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- risk_type column def  -->
      <ng-container matColumnDef="risk_type">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ gridColNames.risk_type }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="risk-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container
            *ngIf="!elem.dataObj.isLoading && elem.dataObj.risk_type"
          >
            <span class="cell-value">
              {{ elem.dataObj.risk_type }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- period column def -->
      <ng-container *ngFor="let colKey of periodList">
        <ng-container [matColumnDef]="colKey + ''">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="period"
            [mat-sort-header]="colKey + ''"
            [disabled]="viewBy === 'revision'"
          >
            <span class="header-text">{{ colKey }}</span>
          </th>

          <td
            mat-cell
            *matCellDef="let elem"
            class="period-cell"
            (click)="loadFormulaBar(elem.dataObj, colKey, elem.parentCtag)"
            [ngClass]="{
              'cell-selected':
                selectedCell ===
                elem.dataObj.drug_name +
                  '_' +
                  elem.dataObj.ticker +
                  '|' +
                  colKey
            }"
          >
            <ng-container *ngIf="elem.dataObj.isLoading">
              <span class="cell-value">
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </span>
            </ng-container>
            <ng-container *ngIf="!elem.dataObj.isLoading">
              <span
                class="cell-value"
                [ngClass]="{
                  'cell-negative':
                    elem.dataObj.period_data[colKey].includes('(')
                }"
              >
                {{ elem.dataObj.period_data[colKey + ""] }}
              </span>
            </ng-container>
          </td>
          <td mat-footer-cell *matFooterCellDef class="total-cell">
            <ng-container *ngIf="isTotalLoading">
              <span class="cell-value">
                <nz-skeleton
                  [nzTitle]="true"
                  [nzActive]="true"
                  [nzParagraph]="false"
                ></nz-skeleton>
              </span>
            </ng-container>

            <ng-container *ngIf="!isTotalLoading">
              <span
                class="cell-value"
                [ngClass]="{
                  'cell-negative':
                    totalLineData?.total_line_data[colKey].includes('(')
                }"
              >
                {{ totalLineData?.total_line_data[colKey + ""] }}
              </span>
            </ng-container>
          </td>
        </ng-container>
      </ng-container>

      <!-- Disclaimer column -->
      <ng-container matColumnDef="disclaimer" sticky class="table-header">
        <td
          mat-footer-cell
          *matFooterCellDef
          [attr.colspan]="displayColumns.length"
        >
          <div class="footer">
            <div class="left-section"></div>
            <div class="right-section">
              <span>{{ magnitudeMsg }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Max Sales column def  -->
      <ng-container matColumnDef="max_value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="max_value">
          <span class="header-text">{{ gridColNames.max_value }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let elem"
          class="peak-sales-cell"
          (click)="
            loadFormulaBarNonPeriod(
              elem.dataObj,
              'max_value',
              elem.ctag,
              elem.parentCtag
            )
          "
          [ngClass]="{
            'cell-selected':
              selectedCell ===
              elem.dataObj.drug_name +
                '_' +
                elem.dataObj.ticker +
                '|' +
                'max_value'
          }"
        >
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container
            *ngIf="!elem.dataObj.isLoading && elem.dataObj.max_value"
          >
            <span class="cell-value">
              {{ elem.dataObj.max_value.value }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Max Sales year column def  -->
      <ng-container matColumnDef="max_year">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="max_year">
          <span class="header-text">{{ gridColNames.max_year }}</span>
        </th>
        <td mat-cell *matCellDef="let elem" class="max_year-cell">
          <ng-container *ngIf="elem.dataObj.isLoading">
            <span class="cell-value">
              <nz-skeleton
                [nzTitle]="true"
                [nzActive]="true"
                [nzParagraph]="false"
              ></nz-skeleton>
            </span>
          </ng-container>
          <ng-container *ngIf="!elem.dataObj.isLoading">
            <span class="cell-value">
              {{ elem.dataObj.max_year }}
            </span>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Final display rows -->
      <tr
        mat-header-row
        *matHeaderRowDef="displayColumns; sticky: true"
        class="table-header"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayColumns"
        [ngClass]="{
          'row-selected':
            row.dataObj.drug_name + '_' + row.dataObj.ticker === selectedDrug,
          'indication-row':
            gridSettings.options.filter.indication.length &&
            row.dataObj.consolidated
        }"
        (click)="onRowClick(row)"
      ></tr>
      <tr mat-footer-row *matFooterRowDef="displayColumns; sticky: true"></tr>
    </table>
  </div>
  <div class="footer">
    <div class="left-section">
      <div
        *ngIf="gridSettings.options.filter.indication.length"
        class="indication-message"
      >
        <div style="margin-bottom: 1px">
          Rows highlighted in gray do not have indication breakouts. To use
          consolidated revenues in its place,
          <a (click)="openDataRevisionPopup()"
            >see settings under Data/Revisions</a
          >
        </div>
      </div>
    </div>
    <div class="right-section">
      <span>{{ magnitudeMsg }}</span>
    </div>
  </div>
</div>

<div
  style="visibility: hidden; position: fixed"
  [style.left]="contextMenuPosition.x"
  [style.top]="contextMenuPosition.y"
  [matMenuTriggerFor]="contextMenu"
></div>

<mat-menu #contextMenu="matMenu" class="mat-menu-container">
  <ng-template matMenuContent let-item="item">
    <ng-container *ngIf="!contextMenuReady">
      <ul nz-menu style="width: 200px">
        <li style="padding: 0px 15px 10px 15px">
          <nz-skeleton
            [nzTitle]="true"
            [nzActive]="true"
            [nzParagraph]="false"
          ></nz-skeleton>
        </li>
      </ul>
    </ng-container>
    <div class="auditClickContainer" *ngIf="contextMenuReady">
      <div
        class="auditClick"
        *ngIf="sourceAvailable"
        (click)="auditSource(item.element, item.colName)"
      >
        Audit Sources
      </div>
      <div class="auditClickSourceNotAvailable" *ngIf="!sourceAvailable">
        Source Not Available
      </div>
    </div>
  </ng-template>
</mat-menu>
